import React, { useEffect, useState } from "react";
import { Table, Spinner,Card, CardBody, CardHeader, Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import axiosInstance from "../../Request";
import { URL } from "../../api";

const Statement = () => {
  const { cid , lid } = useParams();

  const [settlements, setSettlements] = useState([]);
  const [paidEmis, setPaidEmis] = useState([]);
  const [feeSummary, setFeeSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRow, setExpandedRow] = useState(null);
  const [foreclosureSummary, setForeclosureSummary] = useState(null);
  const [foreclosureSummaryMap, setForeclosureSummaryMap] = useState({});





  useEffect(() => {
  const fetchData = async () => {
    try {
      const results = await Promise.allSettled([
        axiosInstance.get(`${URL.SETTLEMENT}?customerId=${cid}&leadId=${lid}`, {
          withCredentials: true,
        }),
        axiosInstance.get(`${URL.SETTLEMENT_PAID}?customerId=${cid}&leadId=${lid}`, {
          withCredentials: true,
        }),
        axiosInstance.get(`${URL.FEES_SUMMERY}?customerId=${cid}&leadId=${lid}`),
        axiosInstance.get(`${URL.FORECLOSURE_SUMMARY}?customerId=${cid}`),
      ]);

      const [settlementRes, paidEmiRes, feeSummaryRes, summaryRes] = results;

      if (settlementRes.status === "fulfilled") {
        setSettlements(Array.isArray(settlementRes.value.data) ? settlementRes.value.data : []);
      }

      if (paidEmiRes.status === "fulfilled") {
        setPaidEmis(Array.isArray(paidEmiRes.value.data) ? paidEmiRes.value.data : []);
      }

      if (feeSummaryRes.status === "fulfilled") {
        setFeeSummary(Array.isArray(feeSummaryRes.value.data) ? feeSummaryRes.value.data : []);
      }

          if (summaryRes.status === "fulfilled") {
        const data = summaryRes.value.data || {};
        setForeclosureSummaryMap(data);
      }

    } catch (error) {
      console.error("Unexpected error during data fetch:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [cid, lid]);

const aggregateForeclosureSummary = (summaryMap) => {
  const total = {
    total_outstanding_emi: 0,
    total_outstanding_principal: 0,
    total_outstanding_interest: 0,
    total_outstanding_fees: 0,
    foreclosure_total_amount: 0,
    force_foreclosure_total_amount: 0,
    foreclosure_fee: 0,
    force_foreclosure_fee: 0,
    foreclosure_fee_percent: null,
    force_foreclosure_fee_percent: null,
    rollback_total_amount: 0,
    leadIds: [],
    all_rollback_total_amount: 0
  };

  for (const key in summaryMap) {
    if (key === "all_rollback_payments" || key === "all_rollback_total_amount") continue;
    const summary = summaryMap[key];
    const leadMatch = key.match(/lead_id=(\d+)/);
    if (leadMatch) total.leadIds.push(leadMatch[1]);

    total.total_outstanding_emi += summary.total_outstanding_emi ?? 0;
    total.total_outstanding_principal += summary.total_outstanding_principal ?? 0;
    total.total_outstanding_interest += summary.total_outstanding_interest ?? 0;
    total.total_outstanding_fees += summary.total_outstanding_fees ?? 0;
    total.foreclosure_total_amount += summary.foreclosure_total_amount ?? 0;
    total.force_foreclosure_total_amount += summary.force_foreclosure_total_amount ?? 0;
    total.foreclosure_fee += summary.foreclosure_fee ?? 0;
    total.force_foreclosure_fee += summary.force_foreclosure_fee ?? 0;
    total.rollback_total_amount += summary.rollback_total_amount ?? 0;

    // Use first non-null percentages
    if (total.foreclosure_fee_percent == null && summary.foreclosure_fee_percent != null)
      total.foreclosure_fee_percent = summary.foreclosure_fee_percent;
    if (total.force_foreclosure_fee_percent == null && summary.force_foreclosure_fee_percent != null)
      total.force_foreclosure_fee_percent = summary.force_foreclosure_fee_percent;
  }
  // Add this line to support new rollback field
  if (summaryMap.all_rollback_total_amount != null) {
    total.all_rollback_total_amount = summaryMap.all_rollback_total_amount;
  }

  return total;
};

  const toggleExpand = (rowId) => {
    setExpandedRow((prev) => (prev === rowId ? null : rowId));
  };

  const formatCurrency = (value) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(value ?? 0);
};


  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const pad = (n) => n.toString().padStart(2, "0");
    const ms = date.getMilliseconds().toString().padStart(3, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}.${ms}`;
  };

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB");
  };

  const normalizeDate = (date) => new Date(date).toISOString().split("T")[0];

  const getChargeAmountForRange = (fromDate, toDate, type = "total") => {
    const matched = feeSummary.find(
      (summary) =>
        normalizeDate(summary.fromEmiDate) === normalizeDate(fromDate) &&
        normalizeDate(summary.toEmiDate) === normalizeDate(toDate)
    );

    if (!matched) return 0;

    if (type === "outstanding") {
      return matched.outstanding ?? 0;
    }

    return matched.charge ?? 0;
  };

  const renderCharges = (fromDate, toDate) => {
    const from = new Date(fromDate);
    const to = new Date(toDate);

    const matchedEntries = feeSummary.flatMap((summary) =>
      summary.details.filter((entry) => {
        const createDate = new Date(entry.createDate);
        return createDate >= from && createDate <= to;
      })
    );

    if (!matchedEntries.length) {
      return <div className="text-muted">No charges for this EMI period.</div>;
    }

  


    return (
      
      <div style={{ padding: "10px" }}>
        <Table size="sm" bordered>
          <thead className="thead-light">
            <tr>
              <th>Create Date</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Outstanding</th>
              <th>Paid</th>
            </tr>
          </thead>
          <tbody>
            {matchedEntries.map((entry, i) =>
              entry.charges.map((charge, j) => (
                <tr key={`${i}-${j}`}>
                  <td>{formatDateTime(entry.createDate)}</td>
                  <td>{charge.type}</td>
                  <td>{formatCurrency(charge.amount)}</td>
                  <td>{formatCurrency(charge.outstandingAmount)}</td>
                  <td>{formatCurrency(charge.paidAmount)}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    );
  };

  const renderTable = (data, title) => {
    const isPaidSection = title === "Paid Details";
    const dataArray = Array.isArray(data) ? data : [];

    return (
      <div
        className="p-3 mb-5"
        style={{
          backgroundColor: isPaidSection ? "#eaecef" : "transparent",
          borderRadius: "8px",
        }}
      >
        <h5 className="mb-3">{title}</h5>
        <Table
          className="align-items-center table-flush"
          responsive
          bordered
          hover
        >
          <thead className="thead-light">
            <tr>
              <th>EMI Date</th>
              <th>{isPaidSection ? "Amount" : "Outstanding Amount"}</th>
              <th>Charges</th>
              <th>Total (EMI + Fee)</th>
            </tr>
          </thead>
          <tbody>
            {dataArray.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">
                  No records found.
                </td>
              </tr>
            ) : (
              dataArray.map((item, index) => {
                const rowId = `${title}-${index}`;
                const isExpanded = expandedRow === rowId;

                const fromDate = item.fromEmiDate || item.emiDate;
                const toDate = item.toEmiDate || item.emiDate;

                const chargeAmount = getChargeAmountForRange(
                  fromDate,
                  toDate,
                  isPaidSection ? "total" : "outstanding"
                );

                const amountToShow = item.outstandingAmount || item.emiAmount;

                return (
                  <React.Fragment key={rowId}>
                    <tr
                      onClick={() => toggleExpand(rowId)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{formatDate(fromDate)}</td>
                      <td>{formatCurrency(amountToShow)}</td>
                      <td>
                        <div className="d-flex justify-content-between align-items-center">
                          <span style={{ fontWeight: "bold" }}>
                            {formatCurrency(chargeAmount)}
                          </span>
                          <span style={{ fontSize: "14px" }}>
                            {isExpanded ? "▼" : "▶"}
                          </span>
                        </div>
                      </td>
                      <td>{formatCurrency(item.totalAmountWithFee)}</td>
                    </tr>
                    {isExpanded && (
                      <tr>
                        <td colSpan="4" style={{ backgroundColor: "#f4f6f8" }}>
                          {renderCharges(fromDate, toDate)}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    );
  };
const aggregatedSummary = aggregateForeclosureSummary(foreclosureSummaryMap);

return (
  <>
   <div className="container">
 {Object.keys(foreclosureSummaryMap).length > 0 && (
  <Card className="shadow mt-4" style={{ backgroundColor: "#e9ecef", color: "#343a40", padding: "1.5rem", borderRadius: "0.5rem" }}>
    <div className="p-2">
      <h4>(Lid: {aggregateForeclosureSummary(foreclosureSummaryMap).leadIds.join(", ")})</h4>
      <Row>
        <Col md="4"><h5>Outstanding EMI Amount:- {formatCurrency(aggregatedSummary.total_outstanding_emi)}</h5></Col>
        <Col md="4"><h5>Outstanding Principal:- {formatCurrency(aggregatedSummary.total_outstanding_principal)}</h5></Col>
        <Col md="4"><h5>Outstanding Interest:- {formatCurrency(aggregatedSummary.total_outstanding_interest)}</h5></Col>
        <Col md="4"><h5>Total Fees:- {formatCurrency(aggregatedSummary.total_outstanding_fees)}</h5></Col>
        <Col md="4"><h5>Foreclosure Fee:- {aggregatedSummary.foreclosure_fee_percent ?? "-"}%</h5></Col>
        <Col md="4"><h5>Force Foreclosure Fee:- {aggregatedSummary.force_foreclosure_fee_percent ?? "-"}%</h5></Col>
        {aggregatedSummary.foreclosure_total_amount !== 0 && (
          <Col md="4"><h5>Foreclosure Amount:- {formatCurrency(aggregatedSummary.foreclosure_total_amount)}</h5></Col>
        )}
        <Col md="4"><h5>Force Foreclosure Amount:- {formatCurrency(aggregatedSummary.force_foreclosure_total_amount)}</h5></Col>
        <Col md="4"><h5>Foreclosure Fee:- {formatCurrency(aggregatedSummary.foreclosure_fee)}</h5></Col>
        <Col md="4"><h5>Force Foreclosure Fee:- {formatCurrency(aggregatedSummary.force_foreclosure_fee)}</h5></Col>
        <Col md="4"><h5>Total RollBack Amount:- {formatCurrency(aggregatedSummary.all_rollback_total_amount)}</h5></Col>
      </Row>
    </div>
  </Card>
)}


  {loading ? (
    <div className="text-center mt-4">
      <Spinner />
    </div>
  ) : (
    <>
      {renderTable(settlements, "Due Details")}
      {renderTable(paidEmis, "Paid Details")}
    </>
  )}
</div>

  </>
);
};

export default Statement;
